import React, { lazy, Suspense } from 'react';
import { Loader } from '../../components/UI/Loader';

const ProposalView = lazy(() =>
  import('../../components/Proposals/View').then(module => ({ default: module.ProposalView }))
);

const PageProposalView: React.FC = () => {
  return (
    <Suspense fallback={<Loader />}>
      <ProposalView />
    </Suspense>
  );
};

export default PageProposalView;
